import { v4 as uuidv4 } from 'uuid';
const PXA_ID = 'pxa_id';
const addPxaId = () => ctx => {
  let pxaId = ctx.cookies.get(PXA_ID);

  // If this middleware hasn't run and the PXA_ID cookie didn't exist, then generate a new value and set it in a
  // cookie and set pxaId so that we will store the value in ctx
  if (!pxaId) {
    pxaId = uuidv4();
    const cookieSettings = [PXA_ID, pxaId, {
      path: '/',
      // 4 years in milliseconds
      maxAge: (4 * 365 + 1) * 24 * 60 * 60 * 1000
    }];
    ctx.cookies.set(...cookieSettings);
  }
};
export default addPxaId;